module.exports = __webpack_public_path__ + "img/history_btn.816b74a7.png";